import React from 'react';
import CrudPage from '../../../components/CrudPage';
import { Button, Badge } from '../../../components/common';
import { AUDIT_COLUMNS } from '../../../config/columns';
import { apiError } from '../../../services/api';
import { partnerService } from '../../../services/resources';

export default function PartnerPage({ onToast }) {
  const toggleBlock = async (row, reload) => {
    try {
      if (row.is_blocked) {
        await partnerService.unblock(row.id);
        onToast?.('Partner / Agent unblocked');
      } else {
        await partnerService.block(row.id);
        onToast?.('Partner / Agent blocked');
      }
      reload();
    } catch (err) {
      onToast?.(apiError(err).message, 'error');
    }
  };

  return (
    <CrudPage
      title="Partner / Agent"
      formCode="PARTNER"
      service={partnerService}
      onToast={onToast}
      formColumns={2}
      searchKeys={['partner_name', 'contact_person', 'phone']}
      columns={[
        { key: 'partner_name', label: 'Name' },
        { key: 'contact_person', label: 'Contact Person' },
        { key: 'phone', label: 'Phone' },
        { key: 'email', label: 'Email' },
        {
          key: 'is_blocked',
          label: 'Status',
          render: (r) => (r.is_blocked ? <Badge tone="red">Blocked</Badge> : <Badge tone="green">Active</Badge>),
        },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        { key: 'partner_name', label: 'Partner / Agent Name', type: 'text', required: true, uppercase: true, fullWidth: true },
        { key: 'contact_person', label: 'Contact Person', type: 'text' },
        { key: 'phone', label: 'Phone', type: 'text' },
        { key: 'email', label: 'Email', type: 'text' },
        { key: 'address', label: 'Address', type: 'textarea' },
        { key: 'remark', label: 'Remark', type: 'textarea' },
      ]}
      rowActions={(row, { reload }) => (
        <Button
          size="sm"
          variant={row.is_blocked ? 'secondary' : 'ghost'}
          onClick={() => toggleBlock(row, reload)}
        >
          {row.is_blocked ? 'Unblock' : 'Block'}
        </Button>
      )}
    />
  );
}
